export const profileKeys = {
  all: ['profile'] as const,
  user: () => [...profileKeys.all, 'user'] as const,
  accountStatus: () => [...profileKeys.all, 'accountStatus'] as const,
  kycDetails: () => [...profileKeys.all, 'kycDetails'] as const,
  kycStatus: () => [...profileKeys.all, 'kycStatus'] as const,
}
